export default (currency) => {
  return /^[£¥¥€$₩฿¢₡₫ƒ₲₴₭₺₼₥₦₱៛₽₹₪৳₮zł]*$/.test(currency)
}
